import { Client } from './client.model';

export class PlanningMultiple {
    datedebut: Date;
    datefin: Date;
    idespace: number;
    idutilisateur: number;
	idclients=[];
	planningstodelete=[];
}


// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/model/planningMultiple.model.ts